<w-button mode="Button" displayStyle="Secondary" [label]="$showLinkSelected() ? 'Link selected' : 'Unlink selected'" [iconLeft]="$showLinkSelected() ? 'fa-regular fa-link-simple'  : 'fa-regular fa-link-simple-slash'" [count]="$safeNavigationMigration(selectionService?.count)" [disabled]="selectionService?.count === 0" [size]="$buttonSize()" (onClick)="link.emit(selectionService.selection)" *ngIf="$isClaims()" />

<div class="activity-header-type">
    <w-button mode="Select" displayStyle="Primary" [size]="$buttonSize()" [commands]="$types()" *ngIf="!$isRemoteClaims() && !$context()?.filterOptions?.hideTypeFilter" />
</div>

<w-search placeholder="Search Activities" size="Small" (search)="$search.set($event)" />

<div class="activity-header-actions">
    <ng-container *ngIf="!$isPortal()">
        <view-options [schema]="$viewOptionsSchema()" [viewOptions]="$viewOptions()" [active]="$hasActiveViewFilters()" label="" [size]="$buttonSize()" [iconLeft]="'fa-regular fa-filter'" (changed)="onViewOptionsChanged($event)" [disabled]="!$newCommands()?.length" *ngIf="!$isRemoteClaims() || !$newCommands()?.length" />
    </ng-container>

    <w-button *ngIf="$context()?.right?.createActivity ?? $context()?.right?.manageActivity" iconLeft="fa-plus" displayStyle="Secondary" [size]="$buttonSize()" [mode]="$newCommands()?.length ? 'Split' : 'Button'" [commands]="$newCommands()" (onClick)="onRaiseAction(ActivityKind.Note)" />
</div>

<!-- <w-button mode="Button"
          displayStyle="Secondary"
          label="Unlink selected"
          iconLeft="fa-regular fa-link-simple-slash"
          [count]="selectionService?.count"
          [disabled]="selectionService?.count === 0"
          (onClick)="link.emit(selectionService.selection)"
          [size]="$buttonSize()" *ngIf="$showUnlinkSelected()" /> -->
